import { SWAppStoreProductInfo } from "./SWAppStoreProduct";
import { SWPlayStoreProductInfo } from "./SWPlayStoreProduct";
export * from "./SWAppStoreProduct";
export * from "./SWBaseProduct";
export * from "./SWBaseProductDetail";
export * from "./SWPlayStoreProduct";
export * from "./localizations";
export const productMap = {
    APP_STORE: SWAppStoreProductInfo,
    PLAY_STORE: SWPlayStoreProductInfo
};
